<template>
    <Question question="If the veteran is deceased, when did they die?">
        <div class="form-group">
            <DateInput label="Date of Death" v-model="deathDay" :required="false"/>   
        </div>
    </Question>
</template>

<script>
import Question from '../Question.vue'
import DateInput from './DateInput.vue'

export default {
  name: 'DeathDay',
  props: {
      question: String
  },
  components: {
    Question,
    DateInput
  },
  created: function() {
    this.$on('save', function() {
        var dod = new Date(this.$data.deathDay);
        var today = new Date();
        if (dod <= today) {
            var oldNext = this.$attrs.next;
            this.$attrs.next = undefined;
            this.$parent.$emit('setCurrentQuestion', "veteranBOS");
            var _this = this;
            setTimeout(function(){
                _this.$attrs.next = oldNext;
            });
        }
    });
  },
  data: function() {
    return {
        "deathDay": "",
    }
  }
}
</script>